import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ContactForm.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/Homepage.css");
